export type Project = 'surselva' | 'obersaxen'

export const SPOT_CONFIG = {
  project: process.env.NEXT_PUBLIC_PROJECT as Project,
  typo3: process.env.NEXT_PUBLIC_TYPO3 as string,
  outdooractive: {
    proj: process.env.NEXT_PUBLIC_OA_PROJ as string,
    key: process.env.NEXT_PUBLIC_OA_KEY as string
  },

  media: {
    desktop: `(min-width: 1024px)`,
    tablet: `(max-width: 1023px)`,
    mobile: `(max-width: 639px)`,
    sm: '(min-width: 640px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)',
    xl: '(min-width: 1280px)',
    '2xl': '(min-width: 1536px)',
    max_sm: '(max-width: 639px)',
    max_md: '(max-width: 767px)',
    max_lg: '(max-width: 1023px)',
    max_xl: '(max-width: 1279px)',
    max_2xl: '(max-width: 1535px)',
    preferSchemaDark: '(prefers-color-scheme: dark)'
  },
  lenis: { lerp: 0.25 },
  theme: false,
  use: {
    analytics: process.env.VERCEL ? true : false,
    cursor: false,
    i18n: true, // if use change (WEB) with [lang]
    jovin: false,
    lenis: true,
    preload: false,
    scrollBar: false,
    theme: false,
    cookiesCheck: true
  },
  debug: {
    cursor: false,
    lenis: false,
    preload: false,
    scrollBar: false
  },
  i18n: {
    defaultLocale: 'de',
    locales: ['en', 'de', 'it'],
    localesMap: {
      en: 'en-US',
      de: 'de-DE',
      it: 'it-IT'
    },
    routes: { en: '/en', de: '/de', it: '/it' },
    names: {
      en: 'English',
      de: 'Deutsh',
      it: 'Italiano'
    }
  } as const
}
export const PROJECT = SPOT_CONFIG.project
export const TYPO3 = SPOT_CONFIG.typo3
export const USE = SPOT_CONFIG.use
export const DEBUG = SPOT_CONFIG.debug
export const MEDIA = SPOT_CONFIG.media
export const i18n = SPOT_CONFIG.i18n
export type Locale = (typeof i18n)['locales'][number]
export const THEME = SPOT_CONFIG.theme
export const OUTDOORACTIVE = {
  ...SPOT_CONFIG.outdooractive
}

export const COLORS = {
  neutral100: 'var(--neutral-100)',
  neutral200: 'var(--neutral-200)',
  neutral300: 'var(--neutral-300)',
  neutral400: 'var(--neutral-400)',
  neutral500: 'var(--neutral-500)',
  neutral600: 'var(--neutral-600)',
  primary100: 'var(--primary-100)',
  primary200: 'var(--primary-200)',
  primary300: 'var(--primary-300)',
  primary400: 'var(--primary-400)',
  green100: 'var(--green-100)',
  green200: 'var(--green-200)',
  green300: 'var(--green-300)',
  green400: 'var(--green-400)',
  red100: 'var(--red-100)',
  red200: 'var(--red-200)',
  red300: 'var(--red-300)',
  red400: 'var(--red-400)',
  shop100: 'var(--shop-100)',
  black: 'var(--black)',
  white: 'var(--white)',
  alpha100: 'var(--alpha-100)',
  alpha200: 'var(--alpha-200)',
  alpha300: 'var(--alpha-300)',
  alpha400: 'var(--alpha-400)',
  blackAlpha100: 'var(--black-alpha-100)',
  blackAlpha200: 'var(--black-alpha-200)',
  blackAlpha300: 'var(--black-alpha-300)',
  blackAlpha400: 'var(--black-alpha-400)',
  feedbackRed: 'var(--color-feedback-red)',
  alphaBlack300: 'var(--color-alpha-black-300)'
}
